import type { ICompanyBank } from "../company/IFullCompanyDto"

export enum HistoryFiltersDirection {
  All = "unset",
  Incoming = "+",
  Outgoing = "-"
}

export enum HistoryFiltersType {
  All = "unset",
  Rep = "rep",
  Xch = "xch",
  Trsf = "trsf",
  Cmm = "cmm",
  Exps = "exps",
  Rfnd = "rfnd",
  Dep = "dep"
}

export type BalanceHistoryFilters = {
  companyId?: string | number
  from?: string
  to?: string
  direction?: string
  direction_label?: string
  bank_id?: string | number
  bankId?: number
  bank_label?: string
  type?: string
  type_label?: string
  contractor?: string
  owner?: string
}

export type BalanceHistoryItem = {
  id: number
  bankId: number
  accountNumber: string
  description: string
  dc: number
  operationType: string | null
  contractor: string | null
  owner: string | null
  stmtDate: string
  bank: ICompanyBank
  operationType_value?: string
  operationType_label?: string
  contractor_value?: string
  contractor_label?: string
  contractor_type?: string
  owner_value?: string
  owner_label?: string
  owner_type?: string
  amount?: number
  contractorId?: string
  contractorType?: string
  ownerId?: string
  ownerType?: string
}

export type BalanceHistoryUpdateFormData = {
  operationType: string
  contractorId: string
  contractorType: string
  ownerId: string
  ownerType: string
  amount?: number
}

export type BalanceHistoryUploadFormData = {
  bankType: string
  zip: string
  force?: boolean
}
